<template>
  <page-wrap>
    <grid
      ref="grid"
      :config="gridConfig"
    />
    <editor :config="{ id: gridConfig.id }" />
  </page-wrap>
</template>

<script>
import gridConfig from './GridConfig.js'
import { waitValue } from '@/utils/promises'

export default {
  name: 'RepairExchangeTd',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'RepairExchangeTd' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    }
  }
}
</script>
